import { z } from 'zod';

export enum HandoffContextEngineeringPlanType {
  All = 'all',
  UserAndAssistantMessages = 'userAndAssistantMessages',
  None = 'none',
  LastNMessages = 'lastNMessages',
}

export const HandoffContextEngineeringPlanSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal(HandoffContextEngineeringPlanType.All) }),
  z.object({ type: z.literal(HandoffContextEngineeringPlanType.UserAndAssistantMessages) }),
  z.object({ type: z.literal(HandoffContextEngineeringPlanType.None) }),
  z.object({
    type: z.literal(HandoffContextEngineeringPlanType.LastNMessages),
    maxMessages: z.number().int().min(1).max(500),
  }),
]);

export type HandoffContextEngineeringPlan = z.infer<typeof HandoffContextEngineeringPlanSchema>;

export const AssistantHandoffToolDestinationSchema = z.object({
  targetAssistantId: z.string().uuid(),
  description: z.string(),
  contextEngineeringPlan: HandoffContextEngineeringPlanSchema.optional(),
});

export type AssistantHandoffToolDestination = z.infer<typeof AssistantHandoffToolDestinationSchema>;

export const AssistantHandoffToolMetadataSchema = z.object({
  destinations: z.array(AssistantHandoffToolDestinationSchema),
});

export type AssistantHandoffToolMetadata = z.infer<typeof AssistantHandoffToolMetadataSchema>;
